import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-access-decision-summary',
    templateUrl: './access-decision-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccessDecisionSummaryComponent {
    @Input() accessRuleId?: string | null;
    @Input() accessRuleDwellSessionId?: string | null;
    @Input() accessRuleName?: string | null;
    @Input() permission?: number | null;
    @Input() alert?: number | null;
    @Input() emptyRuleLabel = 'Default Policy';

    get resolvedRuleName(): string {
        return this.accessRuleName?.trim() || this.emptyRuleLabel;
    }

    get hasRuleLink(): boolean {
        return !!this.accessRuleId && !!this.accessRuleName?.trim();
    }

    get hasDwellSessionLink(): boolean {
        return !!this.accessRuleDwellSessionId;
    }

    permissionBadgeClass(value: number | null | undefined): string {
        return value === 0
            ? 'bg-emerald-50 text-emerald-700 ring-emerald-200'
            : 'bg-rose-50 text-rose-700 ring-rose-200';
    }

    alertBadgeClass(value: number | null | undefined): string {
        switch (value) {
            case 1:
                return 'bg-rose-50 text-rose-700 ring-rose-200';
            case 2:
                return 'bg-amber-50 text-amber-700 ring-amber-200';
            case 3:
                return 'bg-sky-50 text-sky-700 ring-sky-200';
            default:
                return 'bg-slate-100 text-slate-600 ring-slate-200';
        }
    }
}
